import { render } from "./ModalPaymentSummary.vue?vue&type=template&id=661ce394&scoped=true"
import script from "./ModalPaymentSummary.vue?vue&type=script&lang=js"
export * from "./ModalPaymentSummary.vue?vue&type=script&lang=js"

import "./ModalPaymentSummary.vue?vue&type=style&index=0&id=661ce394&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661ce394"]])

export default __exports__